import { cn } from "./classNames-DkX30VJU.js";
import { ChevronLeft, ChevronRight, Ellipsis } from "./icons-DDR9dFSr.js";
import { Button } from "./Button-i0ITjN_1.js";
import { jsx, jsxs } from "react/jsx-runtime";
// src/components/Pagination/PaginationButton.tsx
const PaginationButton = ({ ref, active: isActive = false, className, children, size = "icon", ...props }) => /* @__PURE__ */ jsx(Button, {
	...props,
	ref,
	variant: "invisible",
	size,
	"data-slot": "pagination-link",
	"aria-current": isActive ? "page" : void 0,
	"data-active": isActive,
	className: cn("tw:data-[active=true]:bg-selected", "tw:data-[active=true]:text-selected-foreground", "tw:data-[active=true]:border-selected", className),
	children
});
// src/components/Pagination/PaginationContent.tsx
const PaginationContent = ({ className, ...props }) => /* @__PURE__ */ jsx("ul", {
	...props,
	className: cn("tw:flex", "tw:flex-row", "tw:items-center", "tw:gap-1", className)
});
// src/components/Pagination/PaginationEllipsis.tsx
const PaginationEllipsis = ({ className, ...props }) => /* @__PURE__ */ jsx("span", {
	"aria-hidden": "true",
	className: cn("tw:flex", "tw:p-2.5", "tw:items-center", "tw:justify-center", "tw:text-foreground", "tw:[&_svg:not([class*=\"tw:size-\"])]:size-4", className),
	...props,
	children: /* @__PURE__ */ jsx(Ellipsis, {})
});
// src/components/Pagination/PaginationItem.tsx
const PaginationItem = ({ className, ...props }) => /* @__PURE__ */ jsx("li", {
	className: cn("tw:list-none", className),
	...props
});
// src/components/Pagination/PaginationNext.tsx
const PaginationNext = ({ children, className, ...props }) => /* @__PURE__ */ jsxs(PaginationButton, {
	...props,
	"aria-label": "Go to next page",
	size: "medium",
	className: cn("tw:flex-row-reverse", className),
	children: [/* @__PURE__ */ jsx(ChevronRight, { className: "tw:size-5" }), children ?? "Next"]
});
// src/components/Pagination/PaginationPrevious.tsx
const PaginationPrevious = ({ children, ...props }) => /* @__PURE__ */ jsxs(PaginationButton, {
	...props,
	size: "medium",
	"aria-label": "Go to previous page",
	children: [/* @__PURE__ */ jsx(ChevronLeft, { className: "tw:size-5" }), children ?? "Previous"]
});
// src/components/Pagination/Pagination.tsx
const Pagination = ({ className, ...props }) => /* @__PURE__ */ jsx("nav", {
	...props,
	"aria-label": "pagination",
	className: cn("tailwindcss-preflight", "tw:mx-auto", "tw:flex", "tw:w-full", "tw:justify-center", className)
});
Pagination.Content = PaginationContent;
Pagination.Item = PaginationItem;
Pagination.Button = PaginationButton;
Pagination.Previous = PaginationPrevious;
Pagination.Next = PaginationNext;
Pagination.Ellipsis = PaginationEllipsis;
export { Pagination };

//# sourceMappingURL=Pagination-ByGn8YUL.js.map